import React, { useEffect, useRef, useState } from 'react';


const srcFrom = (obj) => {
  const defaultPath = '/images/41.png';
  let url = '';
  if (!obj) {
    url = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')}${defaultPath}` : defaultPath;
  } else {
    const candidate = obj.img || obj.image || obj.image_url || obj.icon || defaultPath;
    if (/^(https?:)?\/\//i.test(candidate)) {
      url = candidate;
    } else if (candidate.startsWith('/')) {
      url = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')}${candidate}` : candidate;
    } else {
      url = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')}/${candidate}` : candidate;
    }
  }
  // Replace api.apt.com.co with apt.com.co for images
  return url.replace(/api\.apt\.com\.co/gi, 'apt.com.co');
};

export default function ProductGroupSelector({ productGroups = [], onSelect = () => {}, selectedItems = [] }) {
  const [openGroupId, setOpenGroupId] = useState(null);
  const [selectedSubgroups, setSelectedSubgroups] = useState([]);
  const containerRef = useRef(null);


  const fallback = [/* ... you can paste your fallback here or keep empty */];
  const groups = Array.isArray(productGroups) && productGroups.length ? productGroups : fallback;

  const handleMainClick = (g) => {
    setOpenGroupId((prev) => (prev === g.id ? null : g.id));
  };
  const handleSubToggle = (s) => {
    setSelectedSubgroups((prev) => {
      const next = prev.some(p => p.id === s.id) ? prev.filter(p => p.id !== s.id) : [...prev, s];
      // propagate immediately so parent form shows selection live
      onSelect(next);
      return next;
    });
  };
  const handleClear = () => { setSelectedSubgroups([]); onSelect([]); };

  // close dropdown on outside click
  useEffect(() => {
    const onDocClick = (e) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) {
        setOpenGroupId(null);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  // Sync from parent-selected items so external removals reflect in dropdown
  useEffect(() => {
    if (Array.isArray(selectedItems)) {
      setSelectedSubgroups(selectedItems);
    }
  }, [selectedItems]);


  return (
    <div ref={containerRef}>
      <div className="d-flex flex-wrap justify-content-around">
        {groups.map(g => (
          <div key={g.id} className="m-2 text-center position-relative">
            <div onClick={() => handleMainClick(g)} style={{cursor:'pointer'}}>
              <img src={srcFrom(g)} alt={g.name} style={{width:80,height:80,objectFit:'contain'}} />
              <div className="small mt-1">{g.name}</div>
            </div>

            {openGroupId === g.id && (
              <div className="dropdown-menu show" style={{display:'block', position:'absolute', left:0, right:'auto', top:'100%', zIndex:1050, minWidth:220, padding:8}}>
                <div className="text-muted small mb-2">Select categories</div>
                {(g.subgroups || []).map(sub => {
                  const isSelected = selectedSubgroups.some(s => s.id === sub.id);
                  return (
                    <button
                      key={sub.id}
                      type="button"
                      className={`dropdown-item d-flex align-items-center ${isSelected ? 'active' : ''}`}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSubToggle(sub); }}
                    >
                      <img src={srcFrom(sub)} alt={sub.name} style={{width:28,height:28,objectFit:'contain',borderRadius:4,marginRight:8}} />
                      <span className="text-truncate" style={{maxWidth:150}}>{sub.name}</span>
                    </button>
                  );
                })}
                {/* Removed Done/Clear — selection toggles on click; click again to remove */}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
